'use strict';

/**
 * Pure helper: given an integrationTemplate object, return the connect strategy.
 *
 * Returns 'typed' when template.strategy === 'typed' (achievers, workday).
 * Returns 'oauth' for everything else (existing OAuth providers).
 *
 * Exported as CommonJS so it can be required by Mocha unit tests directly,
 * and also registered as an Angular constant via the IIFE below.
 */
function determineConnectStrategy(template) {
    if (template && template.strategy === 'typed') {
        return 'typed';
    }
    return 'oauth';
}

// CommonJS export for Mocha unit tests
if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = { determineConnectStrategy };
}
